import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';

import Selectors from '../selectors';
import Actions from '../action';
import RegistrationPresentational from './register-presentational';

import { getSessionVariable, setSessionVariable, removeSessionVariable, decryptCompanyId } from '@helpers';
import { appConstant, apiUrl } from '@constants';

const RegistrationFunctional = ({ registerLoading, register, history, registerSuccess }) => {
	const { companyId } = useParams();
	const hasValue = getSessionVariable(appConstant.userData);
	const [userData, setuserData] = useState(hasValue || {});
	const [agreed, setagreed] = useState(false);
	const [decryptComId, setDecryptId] = useState('');
	useEffect(() => {
		if (registerSuccess) {
			history.push('/request-received');
		}
	}, [registerSuccess]);
	useEffect(() => {
		getDecryptComId(companyId);
	}, []);

	const getDecryptComId = async (id) => {
		let decryptId = await decryptCompanyId(id)
		setDecryptId(decryptId)
	};

	const goToSignUp = () => {
		history.push('/login');
	};

	const openTerms = () => {
		setSessionVariable(appConstant.userData, userData);
		history.push({
			pathname: '/terms-and-conditions',
			state: { userData },
		});

		//code for opening new window
		// const url = window.location.origin + '/terms-and-conditions';
		// window.open(url, '_self');
		// window.open(url, '_blank');
	};

	const handleValueChange = (event) => {
		setuserData({
			...userData,
			[event.target.name]: event.target.value,
		});
	};

	const onFinish = (value) => {
		const request = {
			firstName: value.firstName || '',
			lastName: value.lastName || '',
			email: value.email || '',
			password: value.password || '',
			phone: value.phone || '',
			businessurl: value.businessurl || '',
			userStatus: value.userStatus || '',
			accessLevel: value.accessLevel || '',
			accountType: value.accountType || '',
			businessName: value.businessName || '',
			companyId: parseInt(decryptComId),
		};
		register(request);
	};

	const clearSessionValues = () => {
		removeSessionVariable(appConstant.userData);
	};

	return (
		<RegistrationPresentational
			registerSuccess={registerSuccess}
			onFinish={onFinish}
			goToSignUp={goToSignUp}
			register={register}
			registerLoading={registerLoading}
			agreed={agreed}
			openTerms={openTerms}
			setAgreed={setagreed}
			handleValueChange={handleValueChange}
			userData={userData}
			clearSessionValues={clearSessionValues}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		registerLoading: Selectors.registerValue(state),
		registerSuccess: Selectors.registerSuccess(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		register: (request) => dispatch(Actions.creators.register(request)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(RegistrationFunctional);

export default Connected;
